var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":_vm.dateToYYYYMMDD(_vm.value)},on:{"input":function($event){return _vm.updateValue($event.target)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }